import {
  initialState,
  Actions,
  State,
  NEW_INSPECTION,
  NEW_INSPECTION_SUCCESS,
  NEW_INSPECTION_ERROR,
  RESET_NEW_INSPECTION,
} from '../../types/inspection/new'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_INSPECTION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_INSPECTION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_INSPECTION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_NEW_INSPECTION:
      return initialState
    default:
      return state
  }
}

export default reducers
